module.exports = __webpack_public_path__ + "static/home-mobile-lead-space-458932d0032c6bb4e501f664dbc70e81.svg";